import { SERVER_PATH } from "../../config/env";
import { errorToaster, successToaster } from "./../../utils/index";
import apiClient from "../../utils/api";

// google auth client id
// export const clienId =
//   "541441021566-lmeq5iub6vvrd78bgnjbmr8gershnu0p.apps.googleusercontent.com";

// sivamfarms
export const clienId =
  "651104114735-c7de7ahbj7hq9vsv6q0dn3a2bmd6f6t7.apps.googleusercontent.com"; //jaanu
// "701517090342-7nu5a174cdsaa1ijjj1erldrid00t94c.apps.googleusercontent.com"; //mangalambika

// google auth success
export const onSuccess = async (data) => {
  const code = await apiClient
    .post(`post/user.php`, {
      user_id: data.email,
      user_name: data.name,
      address: "0",
      mobile_no: "0",
      avatar: data.picture,
      pincode: "0",
      status: "0",
      state: "0",
      no_purchases: "0",
      total_costof_purchases: "0",
    })
    .then((res) => {
      return res.status;
    });
  successToaster({ msg: "Login Successful" });
  return code;
};

// google auth failure
export const onFailure = (res) => {
  errorToaster({ msg: "Somthing went wrong" });
};

// google auth logout
export const onLogoutSuccess = () => {
  successToaster({ msg: "Logout Successful" });
};
